import { render } from "./FAQ.vue?vue&type=template&id=163240e8&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"

import "./FAQ.vue?vue&type=style&index=0&id=163240e8&scoped=true&lang=css"

import exportComponent from "/Users/edvinasjuck/PhpstormProjects/arunvilkasa.lt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163240e8"]])

export default __exports__